module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tofu-icon-component"
  }, [(_vm.iconClass) ? _c('span', {
    staticClass: "icon-font",
    class: _vm.iconClass,
    style: (("font-size: " + _vm.size + "px; \n                line-height: " + _vm.size + "px; \n                color: " + _vm.color + "; \n                transform: scale(" + _vm.scale + ")"))
  }) : _c('img', {
    staticClass: "icon-image",
    style: (("width: " + _vm.size + "px; \n                height: " + _vm.size + "px; \n                transform: scale(" + _vm.scale + ") translate(-50%, -50%)")),
    attrs: {
      "src": _vm.imgSrc
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-7e5fa654!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/tofu-icon/src/icon.vue
// module id = 671
// module chunks = 0